import React from 'react'

import InviteReferralPartners from '@/components/misc/InviteOrRequestReferralPartners/components/InviteReferralPartners'
import RequestReferralPartners from '@/components/misc/InviteOrRequestReferralPartners/RequestReferralPartners'
import { usePermissions } from '@/hooks/usePermissions'

interface Props {
  className?: string
  // Addresses to open the form with, for callers that already know who they want
  // to invite.
  initialEmails?: string[]
}

const InviteOrRequestReferralPartners: React.FC<Props> = ({
  className,
  initialEmails,
}) => {
  const permissions = usePermissions()

  return permissions.canAddPanelDirectly ? (
    <InviteReferralPartners
      className={className}
      initialEmails={initialEmails}
    />
  ) : (
    <RequestReferralPartners
      className={className}
      initialEmails={initialEmails}
    />
  )
}

export default InviteOrRequestReferralPartners
